<template>
  <div class="main">
    <div class="menuContainer" :style="`width:${isHidden?'0':'221px'}`">
      <div class="hiddenIcon" @click="hiddenTab">
        <i :class="isHidden?'el-icon-caret-right':'el-icon-caret-left'" style="color:#fff"/>
      </div>
      <el-menu
        :default-active="pathActive"
        text-color="#335483"
        active-text-color="#fff"
        :unique-opened="true"
        style="width: 221px"
        :style="`transform:translateX(${isHidden?'-221px':'0'});transition: all .3s;`"
        @select="selectMenu"
        router
      >
<!--        v-has="'pc_business_form'"-->
        <el-submenu index="/statistical/order" >
          <template slot="title">
            <i class="el-icon-suitcase-1" style="color:#335483;font-weight: 700"/>
            <span>业务报表</span>
          </template>
<!--          v-has="'pc_order_census'"-->
          <el-menu-item-group >
            <el-menu-item index="/statistical/order">客户订单统计</el-menu-item>
          </el-menu-item-group>
<!--          v-has="'pc_fleet_census'"-->
          <el-menu-item-group >
            <el-menu-item index="/statistical/car">车队统计</el-menu-item>
          </el-menu-item-group>
<!--          v-has="'pc_boat_census'"-->
          <el-menu-item-group>
            <el-menu-item index="/statistical/ship">船舶统计</el-menu-item>
          </el-menu-item-group>
<!--          v-has="'pc_ware_house_census'"-->
          <el-menu-item-group >
            <el-menu-item index="/statistical/warehouse">仓库统计</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
<!--        v-has="'pc_finance_form'"-->
        <el-submenu index="/statistical/income" >
          <template slot="title">
            <i class="el-icon-s-finance" style="color:#335483"/>
            <span>财务报表</span>
          </template>
<!--          v-has="'pc_income_form'"-->
          <el-menu-item-group>
            <el-menu-item index="/statistical/income">收入报表</el-menu-item>
          </el-menu-item-group>
<!--          v-has="'pc_finance_form'"-->
          <el-menu-item-group >
            <el-menu-item index="/statistical/expense">支出报表</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
<!--        v-has="'pc_operate_kb'"-->
        <el-menu-item index="/statistical/operating" >
          <i class="el-icon-s-operation" :style="`color:${this.$route.path==='/statistical/operating'?'#fff':'#335483'}`" style="font-weight: 700"/>
          <span>运营看板</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="content2" :style="`width:${isHidden?'100%':'calc(100% - 221px)'}`" style="background-color: rgb(244, 247, 251);">
      <router-view v-if="$route.path.split('/').length>=3"/>
      <Home v-else/>
      <div class="footer-div">渝ICP备2022002327号-1</div>
    </div>
  </div>
</template>

<script>
import Home from "@/views/home/main"
export default {
  components: {
    Home,
  },

  data() {
    return {
      pathActive: null,
      activeNum: 1,
      isHidden: false,
    };
  },
  watch: {
    $route(to, from) {
      this.pathActive = this.$route.path;
    }
  },
  mounted() {
    this.pathActive = this.$route.path;
  },
  methods: {
    hiddenTab(){
      this.isHidden= !this.isHidden;
    },
    selectMenu() {
      this.activeNum = 0;
    },
  },
};
</script>



<style lang="scss" scoped>
.main{
  width:100%;
  height:100%;
  display: flex;
  .menuContainer{
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    position: relative;
    transition: all .3s;
    height:calc(100vh - 70px);
    .hiddenIcon{
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #48599E;
      width:11px;
      height:50px;
      position: absolute;
      top: calc(50% - 20px);
      right: -11px;
      border-radius: 0 10px 10px 0;
      &:hover{
        cursor: pointer;
      }
    }
  }
  .content{
    width:calc(100% - 221px);
    height:calc(100vh - 70px);
    overflow: auto;
  }
  .content2{
    transition:all .3s;
    width:100%;
    height:calc(100vh - 70px);
    overflow: auto;
  }
  ::v-deep{
    .el-menu-item.is-active {
      background-color: #335483;
    }
    .el-menu-item:focus {
      outline: 0;
      background-color: #335483;
    }
  }
  .content2 > .contract-list, .content2 > .electrify,
  .content2 > .operation, .content2 > .consignSettle,
  .content2 > .portSettle, .content2 > .stockpile,
  .content2 > .warehouse, .content2 > .deferlnvoicing,
  .content2 > .massLoss-list, .content2 > .logisticsConfig,
  .content2 > .finance-income, .content2 > .price-highway,
  .content2 > .main, .content2 > .supplierTrain,
  .content2 > .otherFees, .content2 > .mainContainer {
    height: calc(100% - 30px);
    overflow-y: auto;
  }
  .footer-div {
    display: block;
    position: relative;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 13px;
    color: #a8a8a8;
    background-color: #f4f7fb;
  }
}
</style>
